import React, { Component } from "react";
import 'antd/dist/antd.css';
import { Spinner } from 'reactstrap';
import { Table, Form, Button, Col, Row, Spin, Input, Radio } from "antd";
import axios from '../../utils/request';
//import './HuiHuaCss.css'


const { TextArea } = Input;

const columns = [
    {
        title: '服务商名称',
        dataIndex: 'thirdAppAccountName',
        key: 'thirdAppAccountName',
        width: 120,
    },
    {
        title: '套餐名',
        dataIndex: 'packageName',
        key: 'packageName',
        width: 100,
    },
    {
        title: '职位名称',
        dataIndex: 'jobName',
        key: 'jobName',
        width: 100,
    },
    {
        title: '发起时间',
        dataIndex: 'arrangedTime',
        key: 'arrangedTime',
        width: 120,
    },
    {
        title: '发起人',
        dataIndex: 'arrangedName',
        key: 'arrangedName',
        width: 100,
    },
    {
        title: '状态',
        dataIndex: 'statusName',
        key: 'statusName',
        width: 100,
    },
];

export class LingShuBackGroundRecord extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            loginUser: "",
            commonParamater: "",
            selectedRowKeys: null,
            backGroundRecords: null,
            orderUpdateModel: { tenantId: 0, userId: 0, applyId: "", applicantId: "", jobId: "" , businessId: "", remark: "", isSendResume: 1 },
            applicantModel: { tenantId: 0, userId: 0, applyId: "", applicantId: "", jobId: "" }
        }
    }
    componentDidMount() {
        document.title = '发起补充背调'
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        let tenantId = parseInt(urlParams.get("tenantId"));
        let userId = parseInt(urlParams.get("userId"));
        let applyId = urlParams.get("applyId");
        this.state.commonParamater = commonParamater;

        this.loadPage(commonParamater, tenantId, userId, applyId);
    }

    loadPage = (commonParamater, tenantId, userId, applyId) => {
        this.CheckApplicant(commonParamater);
    };

    CheckApplicant = (commonParamater) => {
        axios.post("/api/LingShu/CheckApplicant", null,
                { params: { commonParamater: commonParamater } })
            .then(res => {
                if (res.status !== 200 || res.data.code !== "200") {
                    const errorMessages = res.data?.message ?? "系统出错，请联系管理员！";
                    console.log("CheckApplicant api error", errorMessages);
                    this.setState({ errorMessage: errorMessages, isLoading: false, isReady: true });
                }
                else {
                    debugger 
                    let applicantModel = {};
                    applicantModel.tenantId = res.data.data.tenantId;
                    applicantModel.userId = res.data.data.userId;
                    applicantModel.applyId = res.data.data.applyId;
                    applicantModel.applicantId = res.data.data.applicantId;
                    applicantModel.jobId = res.data.data.jobId;
                    this.state.applicantModel = applicantModel;
                    const bodyStringApplicantModel = JSON.stringify(applicantModel);
                    this.GetBackGroundRecords(bodyStringApplicantModel);
                }

            }).catch(error => {
                const errorMessages = error?.response?.data?.errorMessages ?? ["系统出错，请联系管理员！"]
                console.log("CheckApplicant api error", errorMessages);
                const errorMessage = errorMessages[0]
                this.setState({ errorMessage, isLoading: false, isReady: true });
            })
            .finally();
    };

    GetBackGroundRecords = (bodyString) => {
        axios.post("/api/LingShu/GetBackGroundRecords",
                bodyString,
                {
                    headers: { "Content-Type": "application/json" }
                })
            .then(res => {
                if (res.data.code == "200") {
                    const data = res.data.data;
                    this.setState({ isLoading: false, isReady: true, backGroundRecords: data });
                }
            })
            .catch(error => {
                debugger
                const errorMessages = error?.response?.data?.errorMessages ?? ["系统出错，请联系管理员！"]
                console.log("GetBackGroundRecords api error", errorMessages);
                const errorMessage = errorMessages[0]
                this.setState({ errorMessage, isLoading: false, isReady: true });
                //window.location.href = "/no_permission";
            })
            .finally();
    };

    submitApi = (bodyString) => {
        axios.post("/api/LingShu/SendOrderUpdate",
                bodyString,
                {
                    headers: { "Content-Type": "application/json" }
                })
            .then(res => {
                let errorMessage = '';
                debugger;
                if (res.data.code == "200") {
                    errorMessage = "提交成功";
                } else {
                    errorMessage = res.data.message;
                }
                this.setState({ errorMessage, isLoading: false, isReady: true });
            })
            .catch(error => {
                debugger
                const errorMessages = error?.response?.data?.errorMessages ?? ["系统出错，请联系管理员！"]
                console.log("SendOrderUpdate api error", errorMessages);
                const errorMessage = errorMessages[0]
                this.setState({ errorMessage, isLoading: false, isReady: true });
                //window.location.href = "/no_permission";
            })
            .finally();
    };

    onFinish = (values) => {
        debugger 
        let summitBodyModel = {};
        summitBodyModel.tenantId = this.state.applicantModel.tenantId;
        summitBodyModel.userId = this.state.applicantModel.userId;
        summitBodyModel.applyId = this.state.applicantModel.applyId;
        summitBodyModel.applicantId = this.state.applicantModel.applicantId;
        summitBodyModel.jobId = this.state.applicantModel.jobId;
        summitBodyModel.remark = values.Remark;
        summitBodyModel.isSendResume = this.state.orderUpdateModel.isSendResume;
        summitBodyModel.businessId = this.state.orderUpdateModel.businessId;
        this.setState({ orderUpdateModel: summitBodyModel });
        this.submitApi(JSON.stringify(summitBodyModel));
    };

    //修改选择
    checkChange = (selectedRowKeys, selectedRows) => {
        //debugger 
        let orderUpdateModel = this.state.orderUpdateModel;
        orderUpdateModel.businessId = selectedRowKeys[0];
        this.setState({ selectedRowKeys: selectedRowKeys, orderUpdateModel: orderUpdateModel });
    };

    onChangeRadio = (e) => {
        debugger 
        let p = e.target.value
        let orderUpdateModel = this.state.orderUpdateModel;
        orderUpdateModel.isSendResume = p;
        this.setState({ orderUpdateModel: orderUpdateModel });
        //setValue(e.target.value);
    };

    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") { if (this.state.errorMessage == "提交成功") {
                            return (<div style={{ textAlign: "center", padding: "32px", fontSize: "22px" }}><span style={{ color: "green" }}>{this.state.errorMessage}</span></div>)
                } else {
            return (<div style={{ textAlign: "center", padding: "32px", fontSize: "22px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
                }
            } else {
                return (
                    <Spin size="large" spinning={this.state.isLoading}>
                        <div style={{ margin: "32px auto", maxWidth: "700px" }}>
                            <Form style={{ "paddingLeft": "5px", "paddingRight": "5px" }} layout="vertical" onFinish={this.onFinish} labelAlign= 'left' labelCol={{ "span": 4 }} wrapperCol={{ "span": 24 }} initialValues={this.state.orderUpdateModel}>
                                <Row>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}  >
                                        <Table columns={columns} dataSource={this.state.backGroundRecords} pagination={false} size="small"
                                            rowKey={record => record.thirdOrderNo}
                                                rowSelection={{
                                                columnTitle: "选择",
                                                columnWidth: '60px',
                                                onChange: this.checkChange,
                                                type: 'radio',
                                                selectedRowKeys: this.state.selectedRowKeys
                                            }}
                                        />
                                    </Col>
                                </Row> 
                                <Row style={{ marginTop:'20px'}}>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Form.Item label="备注" name="Remark" 
                                            rules={[
                                                {
                                                    "required": true,
                                                    "message": "请填写备注"
                                                }
                                            ]}>
                                            <TextArea style={{ minHeight: '120px' }} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: '20px' }}>
                                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <Form.Item label="是否同步简历" name="IsSendResume"
                                            >
                                            <Radio.Group onChange={this.onChangeRadio} defaultValue={1} >
                                            <Radio value={0}>是</Radio>
                                            <Radio value={1}>否</Radio> 
                                            </Radio.Group>
                                        </Form.Item>
                                    </Col>
                                </Row> 
                                <Row style={{ marginTop: '20px', justifyContent: 'center' }}> 
                                    <Col xs={{ span: 4 }} md={{ span: 4 }} lg={{ span: 4 }}>
                                        <Form.Item noStyle>
                                            <Button type="primary" className="float-right" block htmlType="submit">提交</Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </Spin>
                );
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", padding: "15px" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }

    }
}